module.exports = __webpack_public_path__ + "ee61daa1fd7aee4386a54db3b709160c.svg";